// This month's practice questions that score on the /this-month board (Paul, 19 Sep
// 2026: "for this month's practice questions that give bonus, I think we need to
// show it somewhere"). The trainer shows a badge beside the theme label on these.
//
// KEEP IN STEP with `practiceThemes` in content-app/lib/thisMonth.js - that file is
// the source of truth for the board; this copy only drives the badge. The two apps
// are built separately, so the list cannot be imported across.
export const THIS_MONTH_BONUS = {
  points: 2,
  // Per-question exceptions, if any question is ever worth something other than `points` (keep in step with the board).
  pointsById: {},
  ids: [
    // Practice questions theme: Opening hand evaluation
    "bid1-1", "bid1-2", "bid1-3", "bid1-4", "bid1-5",
    // Declarer theme: Knocking out the Ace
    "cp1-3", "cp1-4", "cp1-5", "cp1-6",
    // This month (15 Oct 2026) - newMonth.practiceThemes in content-app/lib/thisMonth.js
    "bid1-34", "bid1-35", "bid1-36", "bid1-37", "bid1-38", // Is this forcing?
    "bid2-9", "bid2-10", "bid2-11", "bid2-12", "bid2-13", // Doubles
    "bid2-29", "bid2-30", "bid2-31", "bid2-32", "bid2-33", // High level doubles
    "bid2-14", "bid2-15", "bid2-16", "bid2-17", "bid2-18", // Responding to a double
    "bid2-19", "bid2-20", "bid2-21", "bid2-22", "bid2-23", // The Power of Pass
  ],
};

// Game Plan points for playing every board of the week's tournament (Paul, 21 Sep 2026).
// KEEP IN STEP with POINTS.tournament in content-app/lib/thisMonth.js.
export const TOURNAMENT_POINTS = 7;

const BONUS_IDS = new Set(THIS_MONTH_BONUS.ids);
export const isThisMonthBonus = (puzzleId) => BONUS_IDS.has(String(puzzleId || ""));
// Points ONE question is worth on the Game Plan ladder (Paul, 15 Oct 2026: "pop up how many points the question awards, not
// always 2, otherwise just general + points"). A question worth something else goes in `pointsById` ({ "bid2-9": 3 });
// everything else is `points`. null = not a bonus question (the pop-up then just says "+ points").
export const bonusPointsFor = (puzzleId) => {
  const id = String(puzzleId || "");
  if (!BONUS_IDS.has(id)) return null;
  const own = THIS_MONTH_BONUS.pointsById && THIS_MONTH_BONUS.pointsById[id];
  return typeof own === "number" ? own : THIS_MONTH_BONUS.points;
};
